/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('trainingProgramEditorComponent', {
                templateUrl: 'training-programs/components/training-program-editor-component.tpl.html',
                controller: function (TrainingProgramEditorService, applicationConstants, CommonLogicService,CommonMasterData,MessageService) {
                    var vm = this;
                    vm.trainingEditorToggle = false;
                    vm.editorMode = "EDIT";
                    vm.base = null;
                    vm.subTrainingPrograms = [];
                    vm.subPrograms = [];
                    vm.IsSIMSelected = false;
                    vm.selectedTrainingProgObj = null;
                    vm.storedTrainingProgObj = null;
                    vm.isNewTrainingSelected = false;

                    vm.clickClosePanel = function (event) {
                        vm.openPanel = false;
                        var option = {
                            panelStatus:vm.openPanel
                        };
                        vm.onClosePanel(option);
                    };

                    vm.changeStation = function () {
                        vm.selectedTraining.trainingLocationObject = null;
                        loadLocationByStation();
                    };

                    vm.changeTime = function (flag) {
                        vm.selectedTraining.duration = TrainingProgramEditorService.calculateDuration(vm.selectedTraining);
                    };

                    vm.changeDuration = function(flag){

                       var duration = moment.duration(vm.selectedTraining.duration).asSeconds();
                       if(vm.selectedTraining.startTime !== null && !angular.isUndefined(vm.selectedTraining.startTime)){
                           const endTime = moment(vm.selectedTraining.startTime, 'HH:mm').add(duration, 'seconds').format('HH:mm');

                           vm.selectedTraining.endTime = endTime;
                       }

                       if(vm.selectedTraining.endTime !== null && !angular.isUndefined(vm.selectedTraining.endTime)){
                           const startTime = moment(vm.selectedTraining.endTime, 'HH:mm').add(-duration, 'seconds').format('HH:mm');

                           vm.selectedTraining.startTime = startTime;
                       }

                    };

                    vm.changeCategory = function () {
                        vm.selectedTraining.programDetailsObject = null;
                        vm.storedTrainingProgObj = null;
                        vm.selectedTrainingProgObj = null;
                        vm.isNewTrainingSelected = false;
                        vm.subPrograms = [];
                    	vm.selectedTraining.subProgramDetailsObject = null;
                      vm.IsSIMSelected = true;
                        loadTrainingProgramDetails();
                    };

                    vm.changeProgram = function () {
                      vm.storedTrainingProgObj = vm.selectedTraining.programDetailsObject;
                    	vm.subPrograms = [];
                        vm.isNewTrainingSelected = false;
                     vm.selectedTraining.subProgramDetailsObject = null;
                    	loadSubProgramDetails();
                      vm.changedProgFlag = true;
                    };

                  vm.setSelectedProgramDetailsObject = function (input) {
                    if(vm.isNewTrainingSelected){
                      vm.selectedTrainingProgObj = TrainingProgramEditorService.getSelectedProgramDetailSByCode(vm.selectedTraining.subPrograms && vm.selectedTraining.subPrograms[0].subProgramCode);
                      vm.selectedTraining.programDetailsObject = vm.selectedTrainingProgObj;
                    }else{
                      vm.selectedTraining.programDetailsObject = vm.storedTrainingProgObj;
                    }
                  }

                  vm.getFilteredProgramDetails= function (input){
                    if(input==" "){
                      return vm.programDetails;
                    }
                    return vm.programDetails.filter(function (trainingProgram) {
                      return trainingProgram['trainingProgCode'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                    });
                  }

                    vm.saveUpdateTraining = function () {
                        saveOrUpdateTraining();
                    };

                    vm.setSingleDay = function(day){
                        if (day.value==='all'){
                            angular.forEach(vm.selectedTraining.selectedDays, function(date,i){
                                if (date.editable){
                                    date.selected = day.selected;
                                }
                            });
                        }
                    };

                    vm.deleteSelected = function () {
                        vm.onDelete();
                    };
                    vm.reSyncSelected = function () {
                        vm.onResync();
                    };

                    vm.changeDate = function(flg){
                        if (vm.selectedTraining.endDate && vm.selectedTraining.startDate){
                            if ('fromDate' == flg){
                                var fD = moment(vm.selectedTraining.startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                                var eD = moment(vm.selectedTraining.endDate, applicationConstants.SETTINGS.DATE_FORMAT);
                                if(eD.diff(fD) < 0){
                                    vm.selectedTraining.endDate = vm.selectedTraining.startDate;
                                }
                            }
                            var fD = moment(vm.selectedTraining.startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                            var eD = moment(vm.selectedTraining.endDate, applicationConstants.SETTINGS.DATE_FORMAT);
                            if (eD.diff(fD)<0 && vm.selectedTraining.endDate.length>4){
                                if ( 'toDate' == flg ){
                                    vm.selectedTraining.startDate = moment(vm.selectedTraining.endDate, applicationConstants.SETTINGS.DATE_FORMAT).format(applicationConstants.SETTINGS.DATE_FORMAT);
                                }
                            }
                            CommonLogicService.applyDaySelection(vm.selectedTraining.selectedDays, vm.selectedTraining.startDate, vm.selectedTraining.endDate);
                        }
                    };

                    vm.$onChanges = function (changeObj) {
                        if(changeObj.selectedTraining && changeObj.selectedTraining &&
                            (changeObj.selectedTraining.currentValue !== changeObj.selectedTraining.previousValue)){
                            if(vm.frmTraining!==undefined){
                                vm.frmTraining.$submitted = false;
                                vm.frmTraining.$setPristine();
                                vm.frmTraining.$setUntouched();
                            }

                            if(vm.selectedTraining.trainingStationCode!==null){
                                loadLocationByStation();
                                vm.editorMode = "EDIT";
                            }else{
                                vm.editorMode = "NEW";
                            }
                            if(vm.selectedTraining.trainingProCategory!==null){
                              vm.isNewTrainingSelected = true;
                                loadTrainingProgramDetails();
                                loadSubProgramDetailsByProgram();
                            }
                        }

                        if(changeObj.stationList && changeObj.stationList &&
                            (changeObj.stationList.currentValue !== changeObj.stationList.previousValue)){
                            TrainingProgramEditorService.setStationList(vm.stationList);
                        }

                        if(changeObj.statusList && changeObj.statusList &&
                            (changeObj.statusList.currentValue !== changeObj.statusList.previousValue)){
                            TrainingProgramEditorService.setStatusList(vm.statusList);
                        }

                        if(changeObj.baseAirportCode && changeObj.baseAirportCode &&
                            (changeObj.baseAirportCode.currentValue !== changeObj.baseAirportCode.previousValue)){
                            TrainingProgramEditorService.setBaseStation(vm.baseAirportCode);
                        }

                        if(changeObj.aircraftCategoryList && changeObj.aircraftCategoryList &&
                            (changeObj.aircraftCategoryList.currentValue !== changeObj.aircraftCategoryList.previousValue)){
                            TrainingProgramEditorService.setAircraftTypes(vm.aircraftCategoryList);
                        }

                        if(changeObj.trainingCategoryList && changeObj.trainingCategoryList &&
                            (changeObj.trainingCategoryList.currentValue !== changeObj.trainingCategoryList.previousValue)){
                            TrainingProgramEditorService.setProgramCategories(vm.trainingCategoryList);
                            vm.trainingCategoryList = TrainingProgramEditorService.getProgramCategories();
                        }

                        if(changeObj.openPanel && changeObj.openPanel &&
                            (changeObj.openPanel.currentValue !== changeObj.openPanel.previousValue)){
                            setStationObject();
                        }


                    };

                    vm.$onInit = function () {

                    };

                    function loadTrainingProgramDetails(){
                        TrainingProgramEditorService.getTrainingProgramDetailsByCategory(vm.selectedTraining.trainingProgramObject.categoryCode,
                            function (programDetailsResults) {
                                vm.programDetails = programDetailsResults;
                                TrainingProgramEditorService.setProgramDetails(vm.programDetails);
                                if(vm.isNewTrainingSelected) {
                                  vm.selectedTraining.programDetailsObject = TrainingProgramEditorService.getSelectedProgramDetailSByCode(vm.selectedTraining.subPrograms && vm.selectedTraining.subPrograms[0].subProgramCode);
                                }
                            },
                            function (error) {}
                        );
                    }

                    function loadSubProgramDetails(){

                    	var subProgramArray = [];

                    	angular.forEach(vm.subTrainingPrograms, function (subProgram) {
                    		if(subProgram.trainingProgramId == vm.selectedTraining.programDetailsObject.trainingProgramId){
                    			subProgramArray = subProgram.trainingSubProgramList;
                    		}
                    	});

                    	vm.subPrograms = subProgramArray;
                    }

                    function loadSubProgramDetailsByProgram(){

                    	var subProgramArray = [];

                    	angular.forEach(vm.subTrainingPrograms, function (subProgram) {
                    		if(subProgram.trainingProgramId == vm.selectedTraining.subPrograms[0].subProgramId){
                    			subProgramArray = subProgram.trainingSubProgramList;
                    		}
                    	});

                    	vm.subPrograms = subProgramArray;
                    }


                    function loadLocationByStation() {
                      vm.trainingLocations = TrainingProgramEditorService.getTrainingLocationByStation(vm.selectedTraining.stationObject.airPortCode);
                      TrainingProgramEditorService.setLocationList(vm.trainingLocations);
                    }

                    function setStationObject() {
                        if(vm.selectedTraining.trainingStationCode===null && vm.baseAirportCode!==null && vm.stationList!==null){
                            vm.selectedTraining.stationObject = TrainingProgramEditorService.getStationByCode(vm.baseAirportCode);
                            loadLocationByStation();
                        }
                    }

                    function saveOrUpdateTraining() {
                        if(vm.frmTraining.$valid){

                            var saveReqTraining = TrainingProgramEditorService.setSelectedToSaveTraining(vm.selectedTraining);

                            if(validateSubProgramData(saveReqTraining)){
                            	var option = {saveRequest: saveReqTraining};
                                vm.onSave(option);
                            }

                        }
                    }

                    function validateSubProgramData(saveRequest){

                    	if(saveRequest){

                    		if(saveRequest.trainingProgramIds == undefined || saveRequest.trainingProgramIds == null ||
                    				saveRequest.trainingProgramIds.length < 1){
                    			MessageService.error("Training program is required.");
                    			return false;
                    		}

                    		if(saveRequest.subProgramId == undefined || saveRequest.subProgramId == null || saveRequest.subProgramId == '' ){
                    			MessageService.error("Available sub program is required.");
                    			return false;
                    		}

                    		return true;
                    	}

                    }


                    /**
                     * Load Base Airport
                     */
                    (function init() {
                    	CommonMasterData.getBaseAirport(function (baseAirport) {
                    		vm.base =  baseAirport;
                            },function () {}
                        );

                    	TrainingProgramEditorService.searchSubPrograms(function (subPrograms) {
                             vm.subTrainingPrograms = subPrograms;
                         }, function (error) {});

                    })();
                },
                bindings: {
                    stationList: '<',
                    allTrainingLocations: '<',
                    baseAirportCode: '<',
                    aircraftCategoryList: '<',
                    statusList: '<',
                    trainingCategoryList: '<',
                    selectedTraining: '<',
                    locationList:'<',
                    openPanel: '<',
                    onSave:'&',
                    onDelete: '&',
                    onResync: '&',
                    onClosePanel:'&'
                }
            }
        )
})();
